import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'; 
import { environment } from '../../../../environments/environment.prod';
import Swal from 'sweetalert2';
import axios from 'axios';
import { EmailService } from '@app/services/Email/email.service';

@Component({
  selector: 'app-verify',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.css']
})
export class PaymentSuccessComponent implements OnInit {
  userInfoId: any;
  itemType: any;
  orderId:any;
  
  constructor(
    private route: ActivatedRoute, 
    private emailService:EmailService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      debugger
      this.userInfoId = params['userInfoId'];
      this.itemType = params['itemType'];
      this.orderId = params['orderId'];
    });
    //this.verifyPayment();
  }
  API_BASE_PATH = environment.API_URL;

  //Phone Pay
  async verifyPayment() { 
    debugger
    const response = await axios.get(`${this.API_BASE_PATH}payment/validate/${this.userInfoId}/${this.itemType}/${this.orderId}`, {
      headers: {
        Accept: "application/json",
        "User-Agent": "axios 0.21.1"
      },
    });
    console.log("received response: ", response.data);
    await this.saveAndEmailPricePlan(null, this.itemType, this.orderId, null);
    if (response.data) {
      Swal.fire({
        title: response.data,
        icon: "success",
        showConfirmButton: false,
        timer: 7700
      });

    } else {
      Swal.fire({
        title: response.data,
        icon: "error",
        showConfirmButton: false,
        timer: 7000
      });
    }
  }

  async saveAndEmailPricePlan(price:any, planType:any, paymentId:any, businessEmail:any) {
    this.emailService.saveAndEmailPricePlan(this.userInfoId, businessEmail, planType, paymentId, price ).subscribe({
      next: (response: any) => {
        if (response) {
          Swal.fire("Plan activated successfully.");
        }
      },
      error: (error: any) => {
        Swal.fire("Email technical issue")
      }
    });
  }
}
